module.exports = __webpack_public_path__ + "static/media/Formular-Medium.85ec99cf.woff2";